import * as server from "@/utils/http"

export const _search = params => server.get("/lis-project/search", params);

export const _lisProjectList = params => server.get("/lis-project/list", params);

export const _generalLisProject = params => server.get("/lis-project/general", params);

export const _copyLisProject = params => server.post("/lis-project/copy", params);

export const _get = params => server.get("/lis-project/get", params);

export const _save = params => server.postfrom(params.id ? "/lis-project/update" : "/lis-project/save", params);

export const _updateStatus = params => server.get("/lis-project/updateStatus", params);

export const _bloodTubeList = params => server.get("/blood-tube/findAll", params);

